/* AV1 PDP — variant selection, add to cart (wired into Pipeline's cart drawer),
   sticky mobile ATC, gallery counter. */
(function () {
  var root = document.querySelector("[data-av1-product]");
  if (!root) return;

  var variantsEl = root.querySelector("[data-variants-json]");
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var optionCount = variants.length && variants[0].options ? variants[0].options.length : 0;

  var form = root.querySelector("[data-product-form]");
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var priceEls = root.querySelectorAll("[data-price]");
  var atcBtn = root.querySelector("[data-atc]");
  var atcLabel = root.querySelector("[data-atc-label]");
  var errorEl = root.querySelector("[data-atc-error]");
  var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* --- selected value per option index --- */
  var selected = [];
  root.querySelectorAll("[data-option-index]").forEach(function (row) {
    var idx = parseInt(row.getAttribute("data-option-index"), 10);
    var current = row.querySelector('[aria-selected="true"]');
    if (current) selected[idx] = current.getAttribute("data-value");
  });

  function currentVariant() {
    return variants.find(function (v) {
      for (var i = 0; i < optionCount; i++) {
        if (selected[i] != null && v.options[i] !== selected[i]) return false;
      }
      return true;
    });
  }

  function refreshAvailability() {
    root.querySelectorAll("[data-option-index]").forEach(function (row) {
      var idx = parseInt(row.getAttribute("data-option-index"), 10);
      row.querySelectorAll("[data-value]").forEach(function (el) {
        var value = el.getAttribute("data-value");
        var anyAvailable = variants.some(function (v) {
          if (v.options[idx] !== value) return false;
          for (var i = 0; i < optionCount; i++) {
            if (i !== idx && selected[i] != null && v.options[i] !== selected[i]) return false;
          }
          return v.available;
        });
        el.setAttribute("data-available", anyAvailable ? "true" : "false");
        if (el.tagName === "BUTTON") el.disabled = !anyAvailable && el.classList.contains("pill");
      });
    });
  }

  function refresh() {
    var v = currentVariant();
    if (!v) return;
    if (idInput) idInput.value = v.id;
    priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? atcLabel.getAttribute("data-add-text") : atcLabel.getAttribute("data-soldout-text");
    }
    refreshAvailability();
    if (typeof setSync === "function") setSync(); /* keep the "wear the set" total and partner size in step */
  }

  /* --- clicks on tiers and pills (both carry data-option-index/data-value) --- */
  root.querySelectorAll("[data-option-index]").forEach(function (row) {
    var idx = parseInt(row.getAttribute("data-option-index"), 10);
    var pickedLabel = row.getAttribute("data-picked") ? document.getElementById(row.getAttribute("data-picked")) : null;
    row.querySelectorAll("[data-value]").forEach(function (el) {
      el.addEventListener("click", function () {
        if (el.getAttribute("data-available") === "false" && el.classList.contains("pill")) return;
        row.querySelectorAll("[data-value]").forEach(function (o) { o.setAttribute("aria-selected", "false"); });
        el.setAttribute("aria-selected", "true");
        selected[idx] = el.getAttribute("data-value");
        if (pickedLabel) pickedLabel.textContent = el.getAttribute("data-value");
        refresh();
      });
    });
  });

  /* --- add to cart: same flow Pipeline uses (add.js -> cart.js -> events -> drawer) --- */
  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.classList.add("is-on");
    setTimeout(function () { errorEl.classList.remove("is-on"); }, 5000);
  }

  var atcBusy = false;
  function setAtcState(state) {
    /* state: "busy" | "added" | "" — subtle feedback on the buy button while the request runs */
    if (!atcBtn || !atcLabel) return;
    atcBtn.classList.toggle("is-busy", state === "busy");
    atcBtn.classList.toggle("is-added", state === "added");
    if (state === "busy") atcLabel.textContent = "Adding\u2026";
    else if (state === "added") atcLabel.textContent = "Added \u2713";
    else atcLabel.textContent = atcLabel.getAttribute("data-add-text") || "Add to cart";
  }

  function addToCart(extraItems, opts) {
    opts = opts || {};
    if (!form || !idInput || !idInput.value || atcBusy) return;
    atcBusy = true;
    setAtcState("busy");
    if (opts.onStart) opts.onStart();
    var cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart ? window.theme.routes.cart : "/cart");
    var request;
    if (extraItems && extraItems.length) {
      /* several lines at once (e.g. the set): JSON items payload */
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }].concat(extraItems);
      request = fetch(cartRoute + "/add.js", {
        method: "POST",
        body: JSON.stringify({ items: items }),
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }
      });
    } else {
      request = fetch(cartRoute + "/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
    }
    request
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || "Could not add to cart"); });
        return r.json();
      })
      .then(function () {
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        atcBusy = false;
        setAtcState("added");
        setTimeout(function () { setAtcState(""); }, 1600);
        if (opts.onDone) opts.onDone(true);
        document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        if (drawer && toggle) {
          toggle.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
        } else {
          /* No cart drawer on this theme (disabled in group-overlay) — show "Added" briefly, then go to the cart page */
          setTimeout(function () {
            window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || "/cart";
          }, 550);
        }
      })
      .catch(function (e) {
        atcBusy = false;
        setAtcState("");
        if (opts.onDone) opts.onDone(false, e);
        if (opts.onError) opts.onError(e.message || "Could not add to cart. Please try again.");
        else showError(e.message || "Could not add to cart. Please try again.");
      });
  }

  /* --- wear the set: partner size selector, live total, add both --- */
  var setBox = root.querySelector("[data-wear-set]");
  var setSync = null;
  if (setBox) {
    var setSelect = setBox.querySelector("[data-set-partner-variant]");
    var setTotal = setBox.querySelector("[data-set-total]");
    var setBtn = setBox.querySelector("[data-set-atc]");
    var setBtnLabel = setBox.querySelector("[data-set-atc-label]");
    var setErr = setBox.querySelector("[data-set-error]");
    var setPartnerPrice = setBox.querySelector("[data-set-partner-price]");
    var sizeIndex = parseInt(setBox.getAttribute("data-size-index"), 10);

    var setUpdateTotal = function () {
      var v = currentVariant();
      var opt = setSelect.options[setSelect.selectedIndex];
      var partnerPrice = opt ? parseInt(opt.getAttribute("data-variant-price"), 10) : 0;
      if (setPartnerPrice && opt) setPartnerPrice.textContent = formatMoney(partnerPrice);
      if (setTotal && v) setTotal.textContent = formatMoney(v.price + partnerPrice);
      var ok = !!(v && v.available && opt && !opt.disabled);
      if (setBtn) setBtn.disabled = !ok;
    };
    /* when the shopper picks a size above, pre-select the same size for the partner if it exists and is in stock */
    setSync = function () {
      if (sizeIndex >= 0 && selected[sizeIndex] != null) {
        var want = String(selected[sizeIndex]).toLowerCase();
        for (var i = 0; i < setSelect.options.length; i++) {
          var o = setSelect.options[i];
          var t = (o.getAttribute("data-title") || o.textContent).toLowerCase();
          var matches = t === want || t.split(" / ").indexOf(want) !== -1;
          if (matches && !o.disabled) { setSelect.selectedIndex = i; break; }
        }
      }
      setUpdateTotal();
    };
    setSelect.addEventListener("change", setUpdateTotal);
    setBtn.addEventListener("click", function () {
      var opt = setSelect.options[setSelect.selectedIndex];
      if (!opt || opt.disabled) return;
      setBtn.classList.add("is-busy");
      if (setBtnLabel) setBtnLabel.textContent = "Adding\u2026";
      addToCart([{ id: parseInt(opt.value, 10), quantity: 1 }], {
        onDone: function (ok) {
          setBtn.classList.remove("is-busy");
          if (setBtnLabel) setBtnLabel.textContent = ok ? "Added \u2713" : setBtnLabel.getAttribute("data-add-text");
          if (ok) setTimeout(function () { setBtnLabel.textContent = setBtnLabel.getAttribute("data-add-text"); }, 1600);
        },
        onError: function (msg) {
          if (setErr) { setErr.textContent = msg; setErr.classList.add("is-on"); setTimeout(function () { setErr.classList.remove("is-on"); }, 5000); }
        }
      });
    });
    setSync();
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      addToCart();
    });
  }
  var stickyBtn = root.querySelector("[data-sticky-atc-btn]");
  if (stickyBtn) stickyBtn.addEventListener("click", addToCart);

  /* --- sticky mobile ATC appears once the buy button scrolls off --- */
  var sticky = root.querySelector("[data-sticky-atc]");
  if (atcBtn && sticky) {
    var stickyTick = false;
    var stickyCheck = function () {
      stickyTick = false;
      /* show once the buy button has scrolled above the viewport */
      sticky.classList.toggle("visible", atcBtn.getBoundingClientRect().bottom < 0);
    };
    var onScroll = function () {
      if (!stickyTick) { stickyTick = true; requestAnimationFrame(stickyCheck); }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    stickyCheck();
  }

  /* --- gallery lightbox (click to zoom) --- */
  var lb = root.querySelector("[data-lightbox]");
  var zoomImgs = Array.prototype.slice.call(root.querySelectorAll("[data-gallery] img[data-zoom-src]"));
  if (lb && zoomImgs.length) {
    var lbImg = lb.querySelector("[data-lb-img]");
    var lbStage = lb.querySelector("[data-lb-stage]");
    var lbCount = lb.querySelector("[data-lb-count]");
    var lbIndex = 0;

    var lbShow = function (i) {
      lbIndex = (i + zoomImgs.length) % zoomImgs.length;
      lb.classList.remove("is-zoomed");
      lbImg.style.transformOrigin = "";
      lbImg.src = zoomImgs[lbIndex].getAttribute("data-zoom-src");
      lbImg.alt = zoomImgs[lbIndex].alt || "";
      lbCount.textContent = (lbIndex + 1) + " / " + zoomImgs.length;
    };
    var lbCloseTimer = null;
    var lbOpen = function (i) {
      lbShow(i);
      if (lbCloseTimer) { clearTimeout(lbCloseTimer); lbCloseTimer = null; }
      lb.hidden = false;
      document.body.style.overflow = "hidden";
      /* two frames so the display change lands before the opacity transition starts */
      requestAnimationFrame(function () { requestAnimationFrame(function () { lb.classList.add("is-open"); }); });
    };
    var lbClose = function () {
      lb.classList.remove("is-open");
      lb.classList.remove("is-zoomed");
      document.body.style.overflow = "";
      lbCloseTimer = setTimeout(function () { lb.hidden = true; lbCloseTimer = null; }, 240);
    };

    zoomImgs.forEach(function (img, i) {
      img.addEventListener("click", function () { lbOpen(i); });
    });
    lb.querySelector("[data-lb-close]").addEventListener("click", lbClose);
    lb.querySelector("[data-lb-prev]").addEventListener("click", function () { lbShow(lbIndex - 1); });
    lb.querySelector("[data-lb-next]").addEventListener("click", function () { lbShow(lbIndex + 1); });

    /* click the image to magnify at that spot; click again to reset */
    lbImg.addEventListener("click", function (e) {
      if (lb.classList.contains("is-zoomed")) {
        lb.classList.remove("is-zoomed");
      } else {
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin =
          ((e.clientX - r.left) / r.width) * 100 + "% " + ((e.clientY - r.top) / r.height) * 100 + "%";
        lb.classList.add("is-zoomed");
      }
      e.stopPropagation();
    });
    /* click the dark backdrop to close */
    lbStage.addEventListener("click", function (e) {
      if (e.target === lbStage) lbClose();
    });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") lbClose();
      else if (e.key === "ArrowLeft") lbShow(lbIndex - 1);
      else if (e.key === "ArrowRight") lbShow(lbIndex + 1);
    });
  }

  /* --- colourways: preview the colour name on hover --- */
  var cwWrap = root.querySelector("[data-colourways]");
  if (cwWrap) {
    var cwName = cwWrap.querySelector("[data-colourway-name]");
    var cwCurrent = cwName ? cwName.textContent : "";
    cwWrap.querySelectorAll(".colourway").forEach(function (sw) {
      sw.addEventListener("mouseenter", function () { if (cwName) cwName.textContent = sw.getAttribute("data-name") || cwCurrent; });
      sw.addEventListener("mouseleave", function () { if (cwName) cwName.textContent = cwCurrent; });
    });
  }

  /* --- description read more --- */
  var rmBody = root.querySelector("[data-readmore]");
  var rmBtn = root.querySelector("[data-readmore-toggle]");
  if (rmBody && rmBtn) {
    var rmDetails = rmBody.closest("details");
    var rmMeasure = function () {
      if (rmBtn.dataset.measured || (rmDetails && !rmDetails.open)) return;
      if (rmBody.scrollHeight > rmBody.clientHeight + 24) {
        rmBtn.hidden = false;
      } else {
        rmBody.classList.remove("is-truncated");
        rmBtn.hidden = true;
      }
      rmBtn.dataset.measured = "1";
    };
    rmMeasure();
    if (rmDetails) rmDetails.addEventListener("toggle", rmMeasure);
    rmBtn.addEventListener("click", function () {
      var from = rmBody.offsetHeight;
      var truncated = rmBody.classList.toggle("is-truncated");
      rmBtn.textContent = truncated ? rmBtn.dataset.more : rmBtn.dataset.less;
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce || !rmBody.animate) return;
      /* glide between the collapsed and expanded heights instead of snapping */
      var to = rmBody.offsetHeight;
      rmBody.style.overflow = "hidden";
      var anim = rmBody.animate(
        [{ maxHeight: from + "px" }, { maxHeight: to + "px" }],
        { duration: 380, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
      );
      anim.onfinish = anim.oncancel = function () { rmBody.style.overflow = ""; };
      if (truncated) {
        /* collapsing: bring the top of the description back into view */
        var top = rmBody.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 120, behavior: "smooth" });
      }
    });
  }

  /* --- mobile gallery counter --- */
  var gallery = root.querySelector("[data-gallery]");
  var count = root.querySelector("[data-gallery-count]");
  if (gallery && count) {
    var total = gallery.querySelectorAll("figure:not(.brand-card)").length;
    gallery.addEventListener("scroll", function () {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      count.textContent = Math.min(Math.max(i, 1), total) + " / " + total;
    }, { passive: true });
  }

  refresh();
})();

/* --- founder video: play on click (section lives outside the product root) --- */
(function () {
  document.querySelectorAll("[data-founder-video]").forEach(function (wrap) {
    var video = wrap.querySelector("video");
    if (!video) return;
    wrap.addEventListener("click", function () {
      if (wrap.classList.contains("is-playing")) return;
      wrap.classList.add("is-playing");
      video.setAttribute("controls", "");
      video.play();
    });
    wrap.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        wrap.click();
      }
    });
  });
})();
